import {firebase} from '../../utilities'
import DB from '../../DAL/DB'
import { auth } from '../../Auth'
import { Timestamp } from 'firebase/firestore'


const projects = new DB.Projects()

export function initializeProject(project) {
  project.startedAt = Timestamp.now()
  project.status = `In Progress`
  return projects.updatebatch(project.id, null, {...project, updatedBy: auth?.sunkaizenUser?.id, updatedByName: auth?.sunkaizenUser?.name })
}
